import { render, staticRenderFns } from "./deliverySelfPickupGoodsOrder.vue?vue&type=template&id=59af55c5&scoped=true"
import script from "./deliverySelfPickupGoodsOrder.vue?vue&type=script&lang=js"
export * from "./deliverySelfPickupGoodsOrder.vue?vue&type=script&lang=js"
import style0 from "./deliverySelfPickupGoodsOrder.vue?vue&type=style&index=0&id=59af55c5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af55c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59af55c5')) {
      api.createRecord('59af55c5', component.options)
    } else {
      api.reload('59af55c5', component.options)
    }
    module.hot.accept("./deliverySelfPickupGoodsOrder.vue?vue&type=template&id=59af55c5&scoped=true", function () {
      api.rerender('59af55c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/deliverySelfPickupGoodsOrder.vue"
export default component.exports